import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDTO } from '../../features/users/api/data/UserDTO';
import { LoginDTO } from '../../features/auth/api/data/LoginDTO';

export enum MODULOS {
  
}



@Injectable()
export class APIService {

  public static API_URL = '';
  public static API_KEY = '';
  public static storage_key = '';
  public static environment = '';
  
  public static loggedUser:UserDTO;
  public static userLogin:LoginDTO;

  /**
   * Token for reset password, used in ResetPasswordPage
   */
  public static resetPasswordToken?:string;

  
  public static TIMEOUT:any = null;

  private static readonly authStorageKey = 'near-live:auth';

  public static saveAuthSession(): void {
    try {
      const payload = {
        userLogin: APIService.userLogin ?? null,
        loggedUser: APIService.loggedUser ?? null,
      };
      localStorage.setItem(APIService.authStorageKey, JSON.stringify(payload));
    } catch {
      return;
    }
  }

  public static restoreAuthSession(): void {
    if (APIService.userLogin?.token) return;
    try {
      const raw = localStorage.getItem(APIService.authStorageKey);
      if (!raw) return;
      const parsed = JSON.parse(raw) as { userLogin?: LoginDTO | null; loggedUser?: UserDTO | null };
      if (parsed?.userLogin) APIService.userLogin = parsed.userLogin;
      if (parsed?.loggedUser) APIService.loggedUser = parsed.loggedUser;
    } catch {
      return;
    }
  }

  public static clearAuthSession(): void {
    try {
      localStorage.removeItem(APIService.authStorageKey);
    } catch {
      return;
    } finally {
      APIService.userLogin = undefined as unknown as LoginDTO;
      APIService.loggedUser = undefined as unknown as UserDTO;
    }
  }

  public static hasValidSession(now: Date = new Date()): boolean {
    APIService.restoreAuthSession();
    const expiration = APIService.userLogin?.expirationDate;
    if (!expiration) return false;
    const expiresAt = new Date(expiration as unknown as string);
    if (Number.isNaN(expiresAt.getTime())) return false;
    return now < expiresAt;
  }
  
  public static clean (obj: any)
  {
    obj = obj.map((v: any)=>{
      v = Object.assign({}, v);
      for( let k in v ) v[k] = "";
      return v;
    });
  }

  /** LOGIN AD */
  public static APPID="aadf21dd-7908-465d-936c-e51fe10976cc";
  public static TENANT="e27ae7e6-02e0-4721-94fd-7abd7e3fabe6";
  public static PACKAGE_NAME="br.com.multiplan.dev.canallojista";
  public static HASH_ANDROID="ga0RGNYHvNM5d0SLGQfpQWAPGJ8%3D";

  public static ageCalculation(fromdate:Date) {
    const todate= new Date();

    var age= [], fromdate= new Date(fromdate),
    y= [todate.getFullYear(), fromdate.getFullYear()],
    ydiff= y[0]-y[1],
    m= [todate.getMonth(), fromdate.getMonth()],
    mdiff= m[0]-m[1],
    d= [todate.getDate(), fromdate.getDate()],
    ddiff= d[0]-d[1];

    if(mdiff < 0 || (mdiff=== 0 && ddiff<0))--ydiff;
    if(mdiff<0) mdiff+= 12;
    if(ddiff<0){
        fromdate.setMonth(m[1]+1, 0);
        ddiff= fromdate.getDate()-d[1]+d[0];
        --mdiff;
    }
    if(ydiff> 0) age.push(ydiff+ ' ano'+(ydiff> 1? 's ':' '));
    if(mdiff> 0) age.push(mdiff+ ' mes'+(mdiff> 1? 'es':''));
    if(ddiff> 0) age.push(ddiff+ ' dia'+(ddiff> 1? 's':''));
    if(age.length>1) age.splice(age.length-1,0,' e ');
    return age.join('');
  }


  public static getHeader() {
    APIService.setTimeOut();

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': APIService.userLogin==undefined?'':APIService.userLogin.token==undefined?'':APIService.userLogin.token,
      'Accept':'application/json',
      'Ocp-Apim-Subscription-Key': APIService.API_KEY
    })
  };

  public static getHeaderResetPassword() {
    APIService.setTimeOut();

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': APIService.resetPasswordToken==undefined?'':APIService.resetPasswordToken,

      'Accept':'application/json',
      'Ocp-Apim-Subscription-Key': APIService.API_KEY
    })
  };

 

  public static setTimeOut(){
    var dt = new Date();
    dt.setMinutes( dt.getMinutes() + 10 );
    APIService.TIMEOUT=dt;

  }

  /** Monitoring */

  public static gAppInsights:any;

  public static Telemetry(page:any, event:any, user:any, customData:any = null) {
    var data;

    if (customData) {
      data = {
        "page" : page,
        "event" : event,
        "data": customData
      }
    } else {
      data = {
        "page" : page,
        "event" : event,
        "name" : user.name,
        "user" : user.userName,
        "email" : user.email,
        "userType" : user.userTypes,
      }
    }
    
    APIService.gAppInsights.trackEvent(page, data);
  }

  /**
   *
   * @param cpf string
   * @returns boolean True para CPF válido e False para CPF inválido
   */
  public static cpfValidation(cpf: string): boolean {
    if (!cpf) return false;

    cpf = cpf.replace(/[\s.-]*/gim, "");

    if (!cpf || cpf.length <= 0) {
      return false;
    } else if (
      cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999"
    ) {
      return false;
    }

    var soma = 0;
    var resto;

    for (var i = 1; i <= 9; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);

    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;

    if (resto != parseInt(cpf.substring(9, 10))) return false;

    soma = 0;

    for (var i = 1; i <= 10; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);

    resto = (soma * 10) % 11;

    if (resto == 10 || resto == 11) resto = 0;

    if (resto != parseInt(cpf.substring(10, 11))) return false;

    return true;
  }

  
}
